module.exports = "/packs/images/navigation/gold-blush-3d539c71d1ae3d9884b6db356a1e96b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/navigation/gold-blush.jpg
// module id = 1811
// module chunks = 0